module.exports = __webpack_public_path__ + "img/void.a528cb22.png";